import { ApiError } from '../model'
import { isJSON } from '@utils'
import noop from 'lodash/noop'

const defaultErrorMessage = 'Unexpected error.'

export interface SpecialResponseHandlers {
  handleUnauthorized: () => void
  handleBanned: () => void
}

export const handleResponse = async (
  response: Response,
  { handleUnauthorized = noop, handleBanned = noop }: SpecialResponseHandlers,
) => {
  const { status } = response

  if (status === 401) {
    const skipLogout = response.headers.get('X-Skip-Logout')

    if (skipLogout === 'true') {
      return
    }

    handleUnauthorized()
  }

  if (status === 403) {
    handleBanned()
  }

  if (status >= 400) {
    const text = await response.text().catch(() => {
      throw new ApiError(status, "Couldn't parse response")
    })

    if (isJSON(text)) {
      const error = JSON.parse(text)
      const errorMessage = error.message || defaultErrorMessage
      throw new ApiError(status, errorMessage)
    } else {
      throw new ApiError(status, text)
    }
  }
}
